export enum ActionCloseReason {
    Close = 'close',
    Submit = 'submit'
}
